module.exports = __webpack_public_path__ + "static/media/logo_CPU.60402ffd.PNG";